module.exports = __webpack_public_path__ + "img/examine_img03.93beca76.png";